import IsIos from '@/mixins/is-ios.js'
import formValidator from '@/mixins/form-validator.js'
import toastStore from '@/stores/toast-store.js'
import logo from '@/assets/images/collectomate-logo.png'
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'

export default {
  name: 'RecoverPassword',
  mixins: [IsIos, formValidator],
  data: function () {
    return {
      errors: {},
      submitted: false,
      logo: logo,

      user: {
        // newPassword: '',
        // confirmNewPassword: '',
        // token: ''
        email: '',
      },

      blocker: false,
      validatedItemKey: 'user',
      showRecoverInfo: false,
    }
  },
  methods: {
    recoverPassword: function (e) {
      e.preventDefault()
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'post',
          url: 'auth/reset_password_instructions',
          data: {
            email: this.user.email,
            pwaContext: this.$slug,
          },
        })
          .then(response => {
            this.blocker = false
            // this.showRecoverInfo = true;
            alert(
              'Wysłaliśmy na twój adres email wiadomość z instrukcją. Zmień hasło klikając na link znajdujący się w wiadomosci.',
            )
            this.$router.push('/')
          })
          .catch(error => {
            this.blocker = false
            const errorMessage = error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
            console.error('error recovering password', error.response)
          })
      }
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          email: {
            required,
            email,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
